import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import Link from "next/link";
import { ColorConf } from "../../config/color";
import { NAVBAR_LINK } from "../../utils/enum";

const StyledFooter = styled("footer")(({ }) => ({
  flex: 1,
  justifyContent: "center",
  alignItems: "center",
  fontSize: 5,
  backgroundColor: ColorConf.PrimaryForWomen,
  width: "100%",
  textAlign: "center",
  color: ColorConf.White,
  fontWeight: 900,
}));

const FooterContentContainer = styled(Box)(({ theme }) => ({
  maxWidth: "390px",
  padding: "32px 24px 12px 24px",
  fontSize: 14,
  margin: "auto"
}));

const StyledP = styled("p")(({ }) => ({
  fontSize: 12,
  fontWeight: 400,
  cursor: "pointer"
}));

const FooterLinks = [
  {
    label: "特定商取引法に関する表記",
    href: "https://company.uraharu.xyz/",
    target: "_blank"
  },
  {
    label: "利用規約",
    href: NAVBAR_LINK.termsOfService,
    target: "_self"
  },
  {
    label: "プライバシーポリシー",
    href: NAVBAR_LINK.privacyPolicy,
    target: "_self"
  },
  {
    label: "初めての方へ",
    href: "https://media-uraharu.com/2022/11/13/%E3%82%A6%E3%83%A9%E3%83%8F%E3%83%AB%E3%81%A8%E3%81%AF/",
    target: "_blank"
  },
  {
    label: "ウラハルの使い方",
    href: "https://note.com/app_uraharu/n/nc907fb4d784c",
    target: "_blank"
  },
  {
    label: "お問合せ",
    href: NAVBAR_LINK.contact,
    target: "_self"
  }
];

const Footer = () => {
  return (
    <StyledFooter>
      <FooterContentContainer>
        <Stack
          direction="row"
          spacing={2}
          flexWrap="wrap"
          gap={3}
          justifyContent="flex-end"
          mr={3.5}
        >
          {FooterLinks.map((link) => (
            <Link
              key={link.label}
              href={link.href}
              target={link.target}
              rel={link.target === "_blank" ? "noopener noreferrer" : undefined}
            >
              <StyledP>{link.label}</StyledP>
            </Link>
          ))}
        </Stack>
        <StyledP sx={{ mt: 6 }}>インターネット異性紹介事業 届出番号:24-098376</StyledP>
      </FooterContentContainer>
    </StyledFooter>
  );
};

export default Footer;
